import type React from 'react';

import type { IdAccountDto, IdContactDto } from '@/services/ws-crm/src/main/resources/rest-api';
import { Link } from '@/js/libs/ui';

interface ContactLinkProps extends React.PropsWithChildren {
  contactId: IdContactDto;
  accountId: IdAccountDto;
  className?: string;
}

export const ContactLink: React.FC<ContactLinkProps> = ({ children, contactId, accountId, className }) => (
  <Link
    to={{
      pathname: `/crm/contacts/edit/${contactId}`,
      search: new URLSearchParams({
        accountId: accountId.toString(),
      }).toString(),
    }}
    className={className}>
    {children}
  </Link>
);
